import * as React from 'react';
import errorExclamation from '@common/bw-ui/icons/animations/errorExclamation.json';
import { AnimatedStateIcon } from '@common/bw-ui/icons/animatedStateIcon';
import { AlertCircleSolidIcon } from '@common/bw-ui/icons/AlertCircleSolidIcon';

/**
 * Animated counterpart to {@link AlertCircleSolidIcon} for invalidated form
 * fields. Falls back to the static icon on the server and under reduced motion.
 */
export function AlertCircleSolidAnimatedIcon(
  props: Omit<
    React.ComponentProps<typeof AnimatedStateIcon>,
    'animationData' | 'fallback'
  >,
) {
  return (
    <AnimatedStateIcon
      animationData={errorExclamation}
      fallback={AlertCircleSolidIcon}
      {...props}
    />
  );
}
